export const AGGREGATED_FILTER_FIELDS = {
  'restrictions-occupation': { postgraduate: 1, undergraduate: 0, 'professional-placement': 1 }
};
